// export interface TimeSlot {
//   id: string;
//   start: string;
//   end: string;
// }

// export interface DateAvailability {
//   date: Date;
//   isAllDay: boolean;
//   timeSlots: TimeSlot[];
// }

// export interface Address {
//   id: string;
//   name: string;
//   street: string;
//   city: string;
//   state: string;
//   pinCode: string;
// }

// export type ScopeType = "shoot_and_edit" | "shoot_only" | null;

// export const DEFAULT_TIME_SLOTS: TimeSlot[] = [
//   { id: "1", start: "9:00 AM", end: "11:00 AM" },
//   { id: "2", start: "11:00 AM", end: "1:00 PM" },
//   { id: "3", start: "2:00 PM", end: "4:00 PM" },
//   { id: "4", start: "4:00 PM", end: "6:00 PM" },
// ];

// types.ts
export type ScopeType = "shoot_and_edit" | "shoot_only" | null;
export const ALL_DAY_SLOT = {
  id: "all-day",
  start: "09:00",
  end: "17:00",
  slotType: "all_day",
  label: "All day",
} as const;
export type SlotType =
  | "morning"
  | "afternoon"
  | "evening"
  | "late_night"
  | "custom"
  | "all_day";

export type TimeSlot = {
  id: string;
  start: string; // "HH:mm"
  end: string; // "HH:mm"
  slotType: SlotType;
  label: string; // "Morning", "Custom"
};

export type DateAvailability = {
  date: Date;
  isAllDay: boolean;
  timeSlots: TimeSlot[];
};

export type Address = {
  id: string;
  title?: string;
  address: string;
  city: string;
  state: string;
  pin_code: string;
};

export const SLOT_PRESETS: {
  slotType: SlotType;
  label: string;
  start: string;
  end: string;
}[] = [
  { slotType: "morning", label: "Morning", start: "09:00", end: "13:00" },
  { slotType: "afternoon", label: "Afternoon", start: "13:00", end: "17:00" },
  { slotType: "evening", label: "Evening", start: "17:00", end: "21:00" },
  { slotType: "late_night", label: "Late Night", start: "01:00", end: "05:00" },
];
